import { useState, useEffect } from "react";
import React from 'react';
import {  useLoaderData, redirect, useRevalidator  } from 'react-router-dom';

import { getResults, getLabConfig, getTableForm } from '../utils/api';
import Results from '../components/Results/Results';

import TestInfoClasses from '../components/Tests/TestInfo.module.css';

const ResultHistory = (props) => {
  const resultHistory = useLoaderData();

  const [PPURL, setPPURL] = useState([]);
  const [tfdata, setTfData] = useState([]);

  useEffect(() => {
    async function fetchPortalTitle() {
      let PPURL2 = "http://localhost:3001";
      if (process.env.NODE_ENV === "production") {
        PPURL2 = await getLabConfig("PPWEBSERVER");
      }
      console.log(PPURL2);
      setPPURL(PPURL2);
    }
    fetchPortalTitle();
  }, []);

  const [webURL, setWebURL] = useState([]);
  useEffect(() => {
    async function fetchLabSetting() {
      const webURL = await getLabConfig("WEBSERVER");
      setWebURL(webURL);
    }
    fetchLabSetting();
  }, []);

  useEffect(() => {
    async function fetchTF() {
      const tf = await getTableForm("PatientPortal:Patient", "ResultHistory");
      setTfData(tf);
    }
    fetchTF();
  }, []);

  return (
    <div className={TestInfoClasses.testInfo}>
      <div className={TestInfoClasses.testInfoContent}>
        <h2 className={TestInfoClasses.testTitle}>Result History</h2>
			<div className={TestInfoClasses.headerRow}>
              {tfdata?.map(({ DBColumn, Label, Name }) => (
                <div key={DBColumn} className={TestInfoClasses.headerCol}>
                  {Label}
                </div>
              ))}
			 </div>
            {resultHistory === "no results" ? (
              <div>No data available.</div>
            ) : (
              resultHistory.map((item) => (
                <Results key={item.id} data={item} tf={tfdata}/>
              ))
            )}
      </div>
    </div>
  );
};

export default ResultHistory;

export async function loader() {
    const response = await getResults();
	const resData = await response;
		if (resData.length) {
			console.log(resData);
			return resData;
		}
}

